import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12.6319 2.99802L15.1119 8.05002C15.2139 8.25902 15.4129 8.40302 15.6419 8.43702L21.1929 9.24802C21.7689 9.33202 21.9999 10.041 21.5839 10.448L17.5619 14.389C17.3969 14.551 17.3219 14.783 17.3609 15.01L18.3089 20.572C18.4069 21.148 17.8019 21.586 17.2849 21.314L12.3269 18.693C12.1209 18.584 11.8739 18.584 11.6689 18.693L6.71088 21.314C6.19488 21.587 5.58888 21.148 5.68688 20.572L6.63488 15.01C6.67388 14.783 6.59888 14.551 6.43388 14.389L2.41388 10.447C1.99888 10.039 2.22888 9.33102 2.80588 9.24702L8.35688 8.43602C8.58688 8.40302 8.78488 8.25802 8.88688 8.04902L11.3669 2.99702C11.6259 2.47202 12.3739 2.47202 12.6319 2.99802V2.99802Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'StarFill');

export default Icon;
